import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function FreeDomainBanner() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <section className="relative w-full py-10 md:py-8 lg:py-5 bg-gradient-to-r from-purple-900/30 to-blue-900/30 border-y border-purple-500/20">
            <div className="container">
                <div className="max-w-6xl mx-auto">
                    {/* Single Line with Toggle */}
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="w-full flex items-center justify-between gap-4 group"
                    >
                        <div className="flex flex-col sm:flex-row items-center gap-3 lg:gap-4 text-center sm:text-left flex-1">
                            <span className="px-4 py-1.5 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-xs font-bold rounded-full uppercase tracking-wider shrink-0">
                                Special Offer
                            </span>
                            <p className="text-lg font-medium text-white">
                                Business Email + Free* Domain Bundle
                            </p>
                        </div>

                        {/* Toggle Icon */}
                        <div className="shrink-0">
                            <div className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center group-hover:bg-white/20 transition-all duration-300">
                                <ChevronDown 
                                    className={`w-5 h-5 text-white transition-transform duration-300 ${
                                        isOpen ? 'rotate-180' : ''
                                    }`}
                                />
                            </div>
                        </div>
                    </button>

                    {/* Expandable Content Below */}
                    <div
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${
                            isOpen ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'
                        }`}
                    >
                        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6">
                            <p className="text-white/90 text-base leading-relaxed mb-4">
                                Save big when you combine a free* domain with custom email, like you@yourdomain, 
                                that instantly boosts your business credibility.
                            </p>
                            {/* <a 
                                href="https://sandomains.com/web-builder/" 
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block px-6 py-2.5 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm font-semibold rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-300"
                            >
                                View Plans & Pricing →
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}